import React, { useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { getDirection } from './lib/i18n'
import { AuthProvider, useAuth } from './hooks/useAuth'
import { usersDB } from './lib/db/users'
import { scheduleReminders } from './lib/notifications'
import Login from './pages/Login'
import Home from './pages/Home'
import TrainingSession from './pages/TrainingSession'
import TrainingSuccess from './pages/TrainingSuccess'
import Settings from './pages/Settings'
import Progress from './pages/Progress'
import Admin from './pages/Admin'
import Leaderboard from './pages/Leaderboard'
import ProtectedRoute from './components/auth/ProtectedRoute'
import ErrorBoundary from './components/common/ErrorBoundary'

function AppContent() {
  const { i18n } = useTranslation()
  const { currentUser } = useAuth()
  const dir = getDirection(i18n.language)

  // Schedule notifications when user is logged in
  useEffect(() => {
    if (currentUser) {
      usersDB.getUserData(currentUser.uid).then(user => {
        if (user.settings.reminderEnabled) {
          scheduleReminders(user);
        }
      });
    }
  }, [currentUser]);

  return (
    <div dir={dir} className="min-h-screen bg-gradient-to-br from-gray-50 via-blue-50/30 to-purple-50/20">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route 
            path="/home" 
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/training" 
            element={
              <ProtectedRoute>
                <TrainingSession />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/training-success" 
            element={
              <ProtectedRoute>
                <TrainingSuccess />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/settings" 
            element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/progress" 
            element={
              <ProtectedRoute>
                <Progress />
              </ProtectedRoute>
            } 
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <Admin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/leaderboard"
            element={
              <ProtectedRoute>
                <Leaderboard />
              </ProtectedRoute>
            }
          />
          <Route path="/" element={<Navigate to="/home" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  )
}

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </ErrorBoundary>
  )
}

export default App
